import QRCode from 'qrcode';

export interface QRCodeData {
  affiliateId: string;
  username?: string;
  timestamp?: string;
}

export class QRCodeService {
  private static instance: QRCodeService;

  private constructor() { }

  public static getInstance(): QRCodeService {
    if (!QRCodeService.instance) {
      QRCodeService.instance = new QRCodeService();
    }
    return QRCodeService.instance;
  }

  /**
   * Generate a QR code data URL for the given affiliate ID
   * @param affiliateId - The affiliate ID to encode
   * @param options - Optional QR code generation options
   * @returns Promise<string> - Data URL of the generated QR code
   */
  async generateQRCode(
    affiliateId: string,
    onlyText?: boolean,
    options: QRCode.QRCodeToDataURLOptions = {},

  ): Promise<string> {
    try {
      const defaultOptions: QRCode.QRCodeToDataURLOptions = {
        width: 300,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF',
        },
        ...options,
      };

      if (onlyText) {
        return await QRCode.toDataURL(affiliateId, defaultOptions);
      }

      // Create a data object with affiliate ID and metadata
      const qrData: QRCodeData = {
        affiliateId,
        timestamp: new Date().toISOString(),
      };

      const dataString = JSON.stringify(qrData);
      const dataUrl = await QRCode.toDataURL(dataString, defaultOptions);

      return dataUrl;
    } catch (error) {
      console.error('Error generating QR code:', error);
      throw new Error('Failed to generate QR code');
    }
  }

  /**
   * Generate a QR code for a simple text string
   * @param text - The text to encode
   * @param options - Optional QR code generation options
   * @returns Promise<string> - Data URL of the generated QR code
   */
  async generateSimpleQRCode(
    text: string,
    options: QRCode.QRCodeToDataURLOptions = {},
  ): Promise<string> {
    try {
      const defaultOptions: QRCode.QRCodeToDataURLOptions = {
        width: 300,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF',
        },
        ...options,
      };

      const dataUrl = await QRCode.toDataURL(text, defaultOptions);
      return dataUrl;
    } catch (error) {
      console.error('Error generating QR code:', error);
      throw new Error('Failed to generate QR code');
    }
  }
}

export default QRCodeService;
